var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppSelector } from "@/hooks/store";
import { ETCRM_URL } from "@/utils/const";
import { faArrowLeft, faCompass, faHouse, faLock, faTriangleExclamation, } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@mui/joy";
import { useTranslation } from "react-i18next";
/**
 *
 * @param {StatusProps} props. Propriétés du composant
 * @returns
 */
export default function (_a) {
    var code = _a.code, title = _a.title, msg = _a.msg, //description
    icon = _a.icon, bgColor = _a.bgColor, textColor = _a.textColor, borderColor = _a.borderColor;
    var t = useTranslation(["common"]).t;
    // Résolution du code : props > router > 404
    var resolvedCode = Number(code !== null && code !== void 0 ? code : 404);
    var errorMessages = {
        403: {
            title: t("app.ERR_ACCESS_DENIED_TITLE", {
                defaultValue: "Accès refusé",
            }),
            description: t("app.ERR_ACCESS_DENIED_DESC", {
                defaultValue: "Vous n'avez pas les autorisations nécessaires pour accéder à cette page. Si vous pensez qu'il s'agit d'une erreur, contactez votre administrateur.",
            }),
            icon: faLock,
        },
        404: {
            title: t("app.ERR_PAGE_NOT_FOUND_TITLE", {
                defaultValue: "Page introuvable",
            }),
            description: t("app.ERR_PAGE_NOT_FOUND_DESC", {
                defaultValue: "La page que vous cherchez n'existe pas ou a été déplacée. Vérifiez l'adresse saisie ou retournez à l'accueil.",
            }),
            icon: faCompass,
        },
        500: {
            title: t("app.ERR_INTERNAL_SERVER_TITLE", {
                defaultValue: "Erreur interne du serveur",
            }),
            description: t("app.ERR_INTERNAL_SERVER_DESC", {
                defaultValue: "L'application vient de rencontrer une situation imprévue. Si le problème persiste, veuillez contacter l'administrateur.",
            }),
            icon: faTriangleExclamation,
        },
    };
    var currentError = errorMessages[resolvedCode] || errorMessages[404];
    var displayTitle = title || currentError.title;
    var displayDescription = msg || currentError.description;
    var iconValue = icon || currentError.icon;
    var systemLogo = useAppSelector(function (state) { return state.systemConfig.systemLogo; });
    return (_jsxs("div", __assign({ className: "relative inset-0 flex flex-col justify-between  px-4 h-full ".concat(bgColor ? bgColor : "bg-[var(--colors-background-body)]") }, { children: [_jsx("div", __assign({ className: "flex flex-1 items-center justify-center py-10" }, { children: _jsxs("div", __assign({ className: "w-full max-w-2xl" }, { children: [systemLogo && (_jsx("div", __assign({ className: "flex justify-center mb-10" }, { children: _jsx("img", { src: "".concat(ETCRM_URL, "/").concat(systemLogo), alt: "EtCRM", className: "max-h-16 opacity-90" }) }))), _jsxs("div", __assign({ className: "bg-[var(--colors-background-level1)] rounded-2xl shadow-xl p-10 md:p-12 text-center border ".concat(borderColor
                                ? bgColor
                                : " border-[var(--color-brand-neutral-200)] dark:border-[var(--color-brand-dark-700)]") }, { children: [_jsxs("div", __assign({ className: "flex flex-col items-center mb-6" }, { children: [_jsxs("div", __assign({ className: "relative" }, { children: [_jsx("div", { className: "absolute inset-0 bg-[var(--colors-link)] opacity-10 blur-2xl rounded-full" }), _jsx(FontAwesomeIcon, { icon: iconValue, className: "relative text-[var(--colors-link)] text-6xl mb-4" })] })), _jsx("div", __assign({ className: "text-7xl md:text-8xl font-bold text-[var(--colors-label)] tracking-tight leading-none" }, { children: resolvedCode }))] })), _jsx("h1", __assign({ className: "text-2xl md:text-3xl font-semibold text-[var(--colors-text-primary)] mb-4" }, { children: displayTitle })), _jsx("p", __assign({ className: "".concat(textColor ? textColor : "text-[var(--colors-label)]", " text-base md:text-lg leading-relaxed mb-10 max-w-lg mx-auto") }, { children: displayDescription })), _jsxs("div", __assign({ className: "flex flex-col sm:flex-row gap-3 justify-center" }, { children: [_jsx(Button, __assign({ variant: "outlined", color: "neutral", size: "lg", startDecorator: _jsx(FontAwesomeIcon, { icon: faArrowLeft }), onClick: function () { return window.history.back(); } }, { children: t("app.LBL_BACK", { defaultValue: "Retour" }) })), _jsx(Button, __assign({ variant: "solid", color: "primary", size: "lg", startDecorator: _jsx(FontAwesomeIcon, { icon: faHouse }), onClick: function () { return (window.location.href = "/"); } }, { children: t("app.LBL_BACK_TO_HOME", {
                                                defaultValue: "Retour à l'accueil",
                                            }) }))] }))] }))] })) })), _jsx("div", __assign({ className: "py-6" }, { children: _jsx("p", __assign({ className: "text-center text-xs ".concat(textColor ? textColor : "text-[var(--colors-label)]", " mt-6 opacity-60") }, { children: t("app.LBL_NEED_HELP", {
                        defaultValue: "Besoin d'aide ? Contactez votre administrateur.",
                    }) })) }))] })));
}
